import cx from 'classnames';

import styles from './Tooltip.scss';

import type { PropsWithChildren } from 'react';

type TooltipFooterProps = PropsWithChildren<{
  mouseIcon: 'left' | 'right';
}>;

const TooltipFooter = ({ children, mouseIcon }: TooltipFooterProps) => (
  <div className={cx(styles.footer, styles[mouseIcon])}>{children}</div>
);

export default TooltipFooter;
